/**
 * Hybrid Container component.
 * Automatically chooses between Tailwind and styled-components based on props.
 */

import * as React from "react";
import StyledContainer from "./styles"; // Styled-components version
import { ContainerTailwind } from "./ContainerTailwind"; // Tailwind version
import { needsStyledComponents } from "@sproutsocial/seeds-react-system-props";
import type { TypeBoxProps } from "@sproutsocial/seeds-react-box";

const ContainerHybrid = React.forwardRef<HTMLDivElement, TypeBoxProps>(
  (props, ref) => {
    // Styled-system props (p, m, color, width, position, …) and styled()
    // extensions route through the styled-components path for backward
    // compatibility. needsStyledComponents reliably hits the SC path for
    // styled(Container) extensions, which hasStyledProps alone would miss.
    if (needsStyledComponents(props)) {
      return <StyledContainer {...props} ref={ref} />;
    }

    // Use Tailwind version (preferred - better performance)
    return <ContainerTailwind {...props} ref={ref} />;
  }
);

ContainerHybrid.displayName = "ContainerHybrid";

export default ContainerHybrid;
